import { CompRef } from '@wix/document-services-types';
import {
  VirtualElement,
  VirtualElementAPIType,
} from '@wix/editor-platform-manifest-services';

import {
  EditorPointer,
  EditorPointerServiceAPI,
} from '@wix/editor-document-logic-api';

export type DisplayElementsMetadataItem = {
  editorPointer: EditorPointer<CompRef>;
  visibilityEditorPointer: EditorPointer<CompRef>;
  key: string | undefined;
  namespace: 'cssProperties' | 'cssCustomProperties';
  preservedVisibleStyleValue: string | undefined;
};

export class MetadataStore {
  #metadata: Record<string, DisplayElementsMetadataItem> = {};

  constructor(private readonly editorPointerAPI: EditorPointerServiceAPI) {}

  getItemByEditorPointer(editorPointer: EditorPointer<CompRef>) {
    return Object.entries(this.#metadata).find(([, { editorPointer: p }]) => {
      return this.editorPointerAPI.isSameEditorPointer(p, editorPointer);
    });
  }

  getAllItemsByEditorPointer(editorPointer: EditorPointer<CompRef>) {
    return Object.entries(this.#metadata).filter(([, { editorPointer: p }]) => {
      return this.editorPointerAPI.isSameEditorPointer(p, editorPointer);
    });
  }

  setItem(id: string, value: DisplayElementsMetadataItem) {
    this.#metadata[id] = value;
  }

  getItem(id: string) {
    return this.#metadata[id];
  }

  getStore() {
    return { ...this.#metadata };
  }

  filterNodesWithExistingEditorPointers(
    nodes: VirtualElement<VirtualElementAPIType.VirtualManifestAPI>[],
  ) {
    return nodes.filter((node) => {
      if (node.isRoot()) {
        return false;
      }

      return !!this.getItemByEditorPointer(node.getEditorPointer());
    });
  }
}
